import * as angular from 'angular';
import {States} from "../../shared/config/constant.module";
import template from './MachineDefectMappings.tpl.html';
import {DefectType} from "../../models/defectType";
import {apsEnums} from "../../shared/dto/aps.enums";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import MachineDefectMappingServiceName, {MachineDefectMappingService} from "../../services/defects/machineDefectMapping.service";
import LineConfigsServiceName, {LineConfigsService} from "../../services/lineConfigs/lineConfigs.service";
import DefectServiceName, {DefectService} from "../../services/defects/defect.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as _ from 'lodash';

let requires = [LoaderServiceName,
                  MachineDefectMappingServiceName, 
                  LineConfigsServiceName, DefectServiceName,DefectTypeServiceName,
                  NotifyServiceName, ShopServiceName, NavigationServiceName, AuthDataServiceName];

interface ViewMachineDefectMappingsController {
  plant: apsViewModels.LookupItem;
  plantSrc: apsViewModels.LookupItem;
  plantNameList: apsViewModels.LookupItem[];
  shops: apsViewModels.ShopItem[];
  selectedShop: apsViewModels.ShopItem;
  selectedShopSrc: apsViewModels.ShopItem;
  machineDefectMappings: apsViewModels.MachineDefectMapping[];
  selectedMachineDefectMapping: apsViewModels.MachineDefectMapping;
  lineEquipmentNames: apsViewModels.LineEquipmentNameItem[];
  defectLossTypes: apsViewModels.DefectLossType[];
  defectTypes: DefectType[];
  selectedEquipmentName: string;
  isPlantAdminOfSelectedPlant: boolean;
 
  populateDefectLossTypes(): void;
  markDirty(id: string): void;
  saveChanges(): void;
  populateMachineList(): void;
  populateMachineDefects(machineName: string): void;
  populateMachineDefectsToBeCopied(machineName: string): void;
  populateStandardDefects(): void;
  onSelectedEquipmentNameChanged(): void;
  getSeverityName(id: string): string;
  initializePlantShops(): void;
  onPlanChanged(): void;
  onCopyPlanChanged(): void;
  onShopChanged(): void;
  setPlantAdminForSelectedPlant(): void;
}

export interface LineEquipmentNameItemDisplay extends apsViewModels.LineEquipmentNameItem {
  locationName: string;
  typeName: string;
}

export default angular.module('aps.controller.machineDefectMappings', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.VIEW_MACHINE_DEFECT_MAPPINGS,
      url: '/machineDefectMappings',
      controller: 'machineDefectMappingsCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Machine Defect Mappings'
      }
    });
  })
  .controller('machineDefectMappingsCtrl', machineDefectMappingsCtrl)
  .name;

function machineDefectMappingsCtrl(
  $modal: mm.foundation.modal,
  loaderService: LoaderService,
  machineDefectMappingService: MachineDefectMappingService,
  lineConfigsService: LineConfigsService,
  defectService: DefectService,
  defectTypeService: DefectTypeService,
  notifyService: NotifyService,
  shopService: ShopService,
  navigationService: NavigationService,
  authDataService: AuthDataService
): ViewMachineDefectMappingsController {
  let vm = {} as ViewMachineDefectMappingsController;

  vm.populateMachineList = function(){
    loaderService.loadingPromise(lineConfigsService
      .getLineEquipmentNames()
    .then(results => {
       this.lineEquipmentNames = results.filter(a=>
          a.name === "CD"
          || a.name === "WBF"
          || a.name === "WSI"
          || a.name === "MX4"
          || a.name === "MULTI"
          || a.name === "MCAL"
          || a.name === "FLXBC"
          || a.name === "FLXM"
          ) as LineEquipmentNameItemDisplay[];
    }));
  }

  vm.populateDefectLossTypes = function(){
    loaderService.loadingPromise(defectService
      .getDefectLossTypes().then(data => {
        this.defectLossTypes = data;
      }));
      return;
  };

  vm.populateStandardDefects = function(){
    var promise = defectTypeService.getDefectTypesAndClassificationsNoExclusion()
    .then(function (defectTypesAndClassifications) {
        vm.defectTypes = defectTypesAndClassifications.types;
    }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
    return;
  };

  vm.populateMachineDefects = function(machineName: string){
    this.machineDefectMappings = null;
    var plantid = vm.plant != undefined ? vm.plant.value : null;
    var shopid = vm.selectedShop != undefined ? vm.selectedShop.id : null;
  
    if(machineName){
      loaderService.loadingPromise(machineDefectMappingService
        .getMachineDefectMappings(machineName, plantid, shopid).then(data => {
          this.machineDefectMappings = data;
        }));
    }
    
    return;
  };

  vm.populateMachineDefectsToBeCopied = function(machineName: string){
    vm.machineDefectMappings = [];
    var plantIdSrc = vm.plantSrc != undefined ? vm.plantSrc.value : null;
    var shopIdSrc = vm.selectedShopSrc != undefined ? vm.selectedShopSrc.id : null;
  
    var plantIdDst = vm.plant != undefined ? vm.plant.value : null;
    var shopIdDst = vm.selectedShop != undefined ? vm.selectedShop.id : null;

    if(machineName){
      loaderService.loadingPromise(machineDefectMappingService
        .getMachineDefectMappingsForCloning(machineName, plantIdSrc, shopIdSrc, plantIdDst, shopIdDst).then(data => {
          // fixing up the selected plant and shop
         
            _.each(data, function(item){
            let newItem: apsViewModels.MachineDefectMapping = {
              id: item.id,
              lineEquipmentNameId: item.lineEquipmentNameId,
              lineEquipmentName: item.lineEquipmentName,
              machineDataPointId: item.machineDataPointId,
              defectTypeId: item.defectTypeId,
              lossTypeId: item.lossTypeId,
              alias: item.alias,
              extensionTag1: item.extensionTag1,
              extensionTag2: item.extensionTag2,
              extensionTag3: item.extensionTag3,
              severity: item.severity,
              displayOrder: item.displayOrder,
              plantId: plantIdDst,
              shopId: shopIdDst,
              headerId: item.headerId,
              machineDataPoint: item.machineDataPoint,
              isDirty: true,
              isNew: item.isNew,
              isIgnored: item.isIgnored
              };

              vm.machineDefectMappings.push(newItem);
          });
          
          
        }));
    }
    
    return;
  };


 vm.getSeverityName = function (id: string): string {
    var defectType = _.find(this.defectTypes, {id: id}) as DefectType;
    if(defectType){
      return apsEnums.Severity[defectType.severity];
    }
    return '';
  }


  vm.saveChanges = function(){

    // save all every time
    if(this.machineDefectMappings && this.machineDefectMappings.length > 0){

      var promise = machineDefectMappingService.saveMachineDefectMappings(this.machineDefectMappings)
      .then(() => {
        alert('Changes saved successfully!');
        this.onSelectedEquipmentNameChanged();
      })
      .catch(notifyService.handleApiErrors);
       loaderService.loadingPromise(promise);
    }
  }

  vm.onSelectedEquipmentNameChanged = function()
  {
    this.populateMachineDefects(this.selectedEquipmentName);
  }

  vm.initializePlantShops = function(){
    let promise = shopService.getShops().then((data: apsViewModels.ShopItem[]) => {
      vm.shops = data;
      vm.plantNameList = [];
      let plantList = _.uniq(_.map(vm.shops, 'plantName')).sort();
      
      _.each(plantList, function(name){
      let found = _.find(vm.shops, {plantName: name});
      if(found){
              let data: apsViewModels.LookupItem = {
                          key: found.plantName,
                          value: found.plantId
                };
                vm.plantNameList.push(data);
            }
      });

      return navigationService.getNavigation().then(nav => {
        
        vm.plant = _.find(vm.plantNameList, {key: nav.selectedPlant.name, value: nav.selectedPlant.id});
   
        this.setPlantAdminForSelectedPlant();
      });
    })

    loaderService.loadingPromise(promise);
  
  }

  vm.onPlanChanged = function()
  { 
     this.machineDefectMappings = null;
     this.selectedShop = null;
     this.selectedEquipmentName = null;
     this.setPlantAdminForSelectedPlant();
  }

  vm.onShopChanged = function()
  {
    this.onSelectedEquipmentNameChanged();
  }

  vm.onCopyPlanChanged = function()
  {
    this.selectedShopSrc = null;
  }

  vm.setPlantAdminForSelectedPlant = function()
  {
    this.isPlantAdminOfSelectedPlant = !(this.plant) ? authDataService.isAPSIOAdmin(): authDataService.isJobChangeSupervisor(this.plant.value);
  }

  vm.initializePlantShops();
  vm.populateMachineList();
  vm.populateStandardDefects();
  vm.populateDefectLossTypes();

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/machineDefectMappings/machineDefectMappings.controller.ts